var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PDF_RESOLUTION, MAX_PDF_SCALE } from "../common/constants";
import { GlobalWorkerOptions, version, getDocument } from 'pdfjs-dist';
GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${version}/pdf.worker.js`;
const getImageFromPage = (_document, pageNumber, resolution = PDF_RESOLUTION) => new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const page = yield _document.getPage(pageNumber);
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        const [, , width, height] = page.view;
        const newScale = Math.pow((resolution / (height * width)), (1 / 2));
        const safeScale = Math.min(newScale, MAX_PDF_SCALE);
        const viewport = page.getViewport({ scale: safeScale });
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        const renderContext = {
            canvasContext: context,
            viewport: viewport,
        };
        page.render(renderContext).promise.then(() => {
            resolve(canvas.toDataURL());
        });
    }
    catch (error) {
        reject(null);
    }
}));
export default function getImagesFromPDF(file, maxPages = Infinity, onSuccess, resolution) {
    return new Promise((resolve, reject) => {
        getDocument(file).promise.then((document) => {
            if (document.numPages > maxPages) {
                reject({ hasPageCountError: true });
                return;
            }
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            Promise.all(Array.from(Array(document.numPages).keys()).map((index) => getImageFromPage(document, index + 1, resolution)))
                .then((images) => {
                resolve(images);
            })
                .catch((e) => {
                reject({ error: e });
            });
        });
    });
}
